<template>
	<v-container>
	  <v-row justify="center">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Calificaciones
            </div>
          </v-card-text>
        </v-card>
      </v-col>

	  	<v-col cols="12" sm="7" md="6" lg="5" v-show="verCalificaciones">
		    <v-expansion-panels class="cardBasic elevation-0">
		    	<!-- Calificaciones -->
		      <v-expansion-panel class="cardBasic mb-4 elevation-0">
		        <v-expansion-panel-header disable-icon-rotate class="py-0">
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title class="text-center">
				          	<v-avatar
					            size="45"
					            color="transparent"
					            rounded
					            :class="`elevation-1  ${ cardsCalificaciones[0].clase }`"
					          >
					          	<v-icon color="white">{{ cardsCalificaciones[0].icono }} </v-icon>
					          </v-avatar>
				            <div class="text-h6">{{ cardsCalificaciones[0].text }}</div>
				          </v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			        	<vue-apex-charts
		              type="radialBar" 
		              height="180" 
		              width="180" 
		              :options="cardsCalificaciones[0].chartOptions" 
		              :series="cardsCalificaciones[0].series"
		            ></vue-apex-charts>
		          </template>
		        </v-expansion-panel-header>

		        <!-- Panel informativo -->
		        <v-expansion-panel-content>
		        	<v-divider></v-divider>
	        		<v-data-table
	        			width="100%"
						    :headers="headersAsistencias"
						    :items="getCalificaciones.asistencias.desgloce"
						    :items-per-page="getCalificaciones.asistencias.desgloce.length"
						    class="elevation-0"
						    :mobile-breakpoint="100"
						    hide-default-footer
						  >
			    			<template v-slot:item.valor_text="{ item }">
			    				<v-chip small rounded :color="item.color">{{item.valor_text}}</v-chip>
			    			</template>
						  </v-data-table>
		        </v-expansion-panel-content>
		      </v-expansion-panel>

		      <!-- Exámenes -->
		      <v-expansion-panel class="cardBasic mb-4 elevation-0">
		        <v-expansion-panel-header disable-icon-rotate class="py-0">
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title class="text-center">
				          	<v-avatar
					            size="45"
					            color="transparent"
					            rounded
					            :class="`elevation-1  ${ cardsCalificaciones[2].clase }`"
					          >
					          	<v-icon color="white">{{ cardsCalificaciones[2].icono }} </v-icon>
					          </v-avatar>
				            <div class="text-h6">{{ cardsCalificaciones[2].text }}</div>
				          </v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			        	<vue-apex-charts
		              type="radialBar" 
		              height="180" 
		              width="180" 
		              :options="cardsCalificaciones[2].chartOptions" 
		              :series="cardsCalificaciones[2].series"
		            ></vue-apex-charts>
		          </template>
		        </v-expansion-panel-header>


		        <!-- Panel informativo -->
		        <v-expansion-panel-content>
		        	<v-divider></v-divider>
	        		<v-data-table
	        			width="100%"
						    :headers="headersEjercicios"
						    :items="getCalificaciones.examenes.desgloce"
						    :items-per-page="getCalificaciones.examenes.desgloce.length"
						    class="elevation-0"
						    :mobile-breakpoint="100"
						    hide-default-footer
						  >
			    			<template v-slot:item.valor_text="{ item }">
			    				<v-chip small rounded :color="item.color">{{item.valor_text}}</v-chip>
			    			</template>
						  </v-data-table>
		        </v-expansion-panel-content>
		      </v-expansion-panel>
		    </v-expansion-panels>
	  	</v-col>

	  	<v-col cols="12" sm="7" md="6" lg="5" v-show="verCalificaciones">
		    <v-expansion-panels class="cardBasic elevation-0">
		      <!-- Ejercicios -->
		      <v-expansion-panel class="cardBasic mb-4 elevation-0">
		        <v-expansion-panel-header disable-icon-rotate class="py-0">
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title class="text-center">
				          	<v-avatar
					            size="45"
					            color="transparent"
					            rounded
					            :class="`elevation-1  ${ cardsCalificaciones[1].clase }`"
					          >
					          	<v-icon color="white">{{ cardsCalificaciones[1].icono }} </v-icon>
					          </v-avatar>
				            <div class="text-h6">{{ cardsCalificaciones[1].text }}</div>
				          </v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			        	<vue-apex-charts
		              type="radialBar" 
		              height="180" 
		              width="180" 
		              :options="cardsCalificaciones[1].chartOptions" 
		              :series="cardsCalificaciones[1].series"
		            ></vue-apex-charts>
		          </template>
		        </v-expansion-panel-header>


		        <!-- Panel informativo -->
		        <v-expansion-panel-content>
		        	<v-divider></v-divider>
	        		<v-data-table
	        			width="100%"
						    :headers="headersEjercicios"
						    :items="getCalificaciones.ejercicios.desgloce"
						    :items-per-page="getCalificaciones.ejercicios.desgloce.length"
						    class="elevation-0"
						    :mobile-breakpoint="100"
						    hide-default-footer
						  >
			    			<template v-slot:item.valor_text="{ item }">
			    				<v-chip small rounded :color="item.color">{{item.valor_text}}</v-chip>
			    			</template>
						  </v-data-table>
		        </v-expansion-panel-content>
		      </v-expansion-panel>

		      <!-- Exámenes -->
		      <v-expansion-panel class="cardBasic mb-4 elevation-0">
		        <v-expansion-panel-header disable-icon-rotate class="py-0">
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title class="text-center">
				          	<v-avatar
					            size="45"
					            color="transparent"
					            rounded
					            :class="`elevation-1  ${ cardsCalificaciones[3].clase }`"
					          >
					          	<v-icon color="white">{{ cardsCalificaciones[3].icono }} </v-icon>
					          </v-avatar>
				            <div class="text-h6">{{ cardsCalificaciones[3].text }}</div>
				          </v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			        	<vue-apex-charts
		              type="radialBar" 
		              height="180" 
		              width="180" 
		              :options="cardsCalificaciones[3].chartOptions" 
		              :series="cardsCalificaciones[3].series"
		            ></vue-apex-charts>
		          </template>
		        </v-expansion-panel-header>


		        <!-- Panel informativo -->
		        <v-expansion-panel-content>
		        </v-expansion-panel-content>
		      </v-expansion-panel>
		    </v-expansion-panels>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
         	:to="{name: 'DetalleGrupo'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta v-if="respuestaAlerta" :parametros="parametros"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'
	import VueApexCharts from 'vue-apexcharts'

	// Importar componentes
  import Alerta     from '@/components/alertas/Alerta.vue'

	export default {
		components: {
	    Alerta,
	    VueApexCharts
	  },

	  name: "dashboard-default",

	  data: () => ({
	  	verCalificaciones: false,

	  	cardsCalificaciones:[
	  		{ text: 'Participación', series: [0], chartOptions: null, icono: 'mdi-account'      , clase: 'avataresAsistencias' },
	  		{ text: 'Ejercicios'   , series: [0], chartOptions: null, icono: 'mdi-file-document', clase: 'avataresEjercicios' },
	  		{ text: 'Exámenes'     , series: [0], chartOptions: null, icono: 'mdi-file-check'   , clase: 'avataresExamenes' },
	  		{ text: 'Total'        , series: [0], chartOptions: null, icono: 'mdi-chart-arc'    , clase: 'avataresTotal' },
	  	],

	  	headersAsistencias: [
        { text: 'Fecha',  value: 'fecha_formato'  , class: 'text-uppercase grey--text text-caption' },
        { text: 'Valor',  value: 'valor_text'     , class: 'text-uppercase grey--text text-caption text-center', align: 'center' },
      ],

      headersEjercicios: [
        { text: 'Lección'     ,  value: 'session'          , class: 'text-uppercase grey--text text-caption' },
        { text: 'Calificación',  value: 'calificacion'     , class: 'text-uppercase grey--text text-caption text-center', align: 'center' },
      ],

	  	asistencias:[],

	  	show: false,

    	respuestaAlerta: false,

      parametros:{
      	dialogError: false,
      	mensaje: ''
     	},

      chart: {
        height: 350,
        type: 'radialBar',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
           hollow: {
            margin: 0,
            size: '70%',
            background: '#fff',
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24
            }
          },

          track: {
            background: '#fff',
            strokeWidth: '67%',
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35
            }
          },
      
          dataLabels: {
            show: true,

            name: {
              offsetY: 5,
              show: true,
              color: 'grey',
              fontSize: '18px'
            },

            value: {
              formatter: function(val) {
                return parseFloat(val) + ' / ';
              },
              color: '#111',
              fontSize: '24px',
              show: false,
            }
          }
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: ['#ABE5A1'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      stroke: {
        lineCap: 'round'
      },
	  }),

	  created () {
	  	const califAsistencias   = this.getCalificaciones.asistencias.pts_total_asistencia
	  	const califAsistenciasL  = this.getCalificaciones.asistencias.limite
	  	const califEjercicios    = this.getCalificaciones.ejercicios.pts_total_ejercicios
	  	const califEjerciciosL   = this.getCalificaciones.ejercicios.limite
	  	const califExamenes      = this.getCalificaciones.examenes.pts_total_examenes
	  	const califExamenesL     = this.getCalificaciones.examenes.limite
	  	const calificacion_total = this.getCalificaciones.calificacion_total


	  	this.cardsCalificaciones[0].series       = [parseFloat(califAsistencias)]
	  	this.cardsCalificaciones[0].chartOptions = {
	  		chart: this.chart,
	  		plotOptions: this.plotOptions,
				fill:  this.fill,
				stroke:this.stroke,
				labels: [`${ parseFloat(califAsistencias)} / ${ parseFloat(califAsistenciasL)}`]
			}

	  	this.cardsCalificaciones[1].series = [parseFloat(califEjercicios)]
	  	this.cardsCalificaciones[1].chartOptions = {
	  		chart: this.chart,
	  		plotOptions: this.plotOptions,
				fill:  this.fill,
				stroke:this.stroke,
				labels: [`${ parseFloat(califEjercicios)} / ${ parseFloat(califEjerciciosL)}`]
			}

	  	this.cardsCalificaciones[2].series = [parseFloat(califExamenes)]
	  	this.cardsCalificaciones[2].chartOptions = {
	  		chart: this.chart,
	  		plotOptions: this.plotOptions,
				fill:  this.fill,
				stroke:this.stroke,
				labels: [`${ parseFloat(califExamenes)} / ${ parseFloat(califExamenesL)}`]
			}

			this.cardsCalificaciones[3].series = [parseFloat(calificacion_total)]
	  	this.cardsCalificaciones[3].chartOptions = {
	  		chart: this.chart,
	  		plotOptions: this.plotOptions,
				fill:  this.fill,
				stroke:this.stroke,
				labels: [`${ parseFloat(calificacion_total)} / 100`]
			}

	  	this.verCalificaciones = true
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getCalificaciones', 'getUsuarioLMS', 'getRecursosGrupoUsuario' ])
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno'] ),

	  }
	};
</script>

<style scoped>
	.avataresAsistencias{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.avataresEjercicios{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background: rgb(240,112,26);
		background: linear-gradient(90deg, rgba(240,112,26,1) 0%, rgba(255,177,103,1) 100%);
	}

	.avataresExamenes{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background: rgb(17,134,24);
		background: linear-gradient(90deg, rgba(17,134,24,1) 0%, rgba(23,201,58,1) 100%);
	}

	.avataresTotal{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background: rgb(134,17,118);
		background: linear-gradient(90deg, rgba(134,17,118,1) 0%, rgba(237,44,223,1) 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.cardBasic{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.colorCurso{
		color: #006093;
	}

</style>
